export default "__VITE_ASSET__dca0ed55__"